import { cssUtil } from "../../utils/cssUtil.js";
import { getBaseStyles } from "../commonStyles.js";
import { getButtonStyles } from "./menuContainer.js";

export async function renderMenuDraggableContainerWidget(
    context,
    widget,
    parent,
    override = null
) {

    const el = context.document.createElement("div");
    el.classList.add("widget", "menu_draggable_container_widget");

    const breakpoint = context.currentBreakpoint;

    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    // Alignment comes from parent Menu widget
    const menuWidget = context.widgets.find(w => w.uid === widget.parent);
    const menuProps = menuWidget?.properties?.desktop;
    const alignment = menuProps?.alignment;

    if (alignment) {
        const position = alignment.position;
        const margin = Math.max(0, parseInt(alignment.margin ?? "0", 10));

        styles["text-align"] = position;

        if (position === "left") {
            styles["padding-left"] = `${margin}px`;
        } else if (position === "right") {
            styles["padding-right"] = `${margin}px`;
        }
    }

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);

    // Menu content wrapper
    const menuContentEl = context.document.createElement("div");
    menuContentEl.classList.add("menu_content");
    menuContentEl.setAttribute(
        "style",
        cssUtil.toStyleString({ width: "auto" })
    );

    el.appendChild(menuContentEl);
    parent.appendChild(el);

    // Render menu items
    const menuItems = widget?.content;
    if (!menuItems || !menuItems.length) return el;

    for (const menuItem of menuItems) {
        const itemEl = context.document.createElement("div");
        itemEl.classList.add("menu_item");

        const itemStyles = getButtonStyles(widget);
        itemEl.setAttribute("style", cssUtil.toStyleString(itemStyles));

        itemEl.innerHTML = menuItem.name;

        menuContentEl.appendChild(itemEl);
    }

    return el;
}